export const processTextForLinks = (text) => {
	const Rexp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?/=~_|!:,.;]*)[-A-Z0-9+&@#/%=~_|])/ig;
	return text.replace(Rexp, "<a href='$1' target='_blank'>$1</a>");
}

export const surnameWithInitials = (person) => {
	if(!person) return ''
	const { lname, fname, mname } = person
	const firstInitial = fname?.trim()?.[0] ? `${fname.trim()[0]}.` : ''
	const middleInitial = mname?.trim()?.[0] ? `${mname.trim()[0]}.` : ''

	if (lname?.trim()) {
		return [lname.trim(), firstInitial, middleInitial].join(' ')
	}

	return [fname?.trim() || '', middleInitial].join(' ')
}

export const padString = (string, limit, padder = '...') => {
	return string.length > limit ? string.substring(0, (limit - padder.length)) + padder : string
}

export const isString = (val) => {
	return typeof val === 'string' || val instanceof String
}
